export class Admin {
  id?: string;
  email: string;
  password?: string;
  firstName: string;
  lastName: string;
  fullName?: string;

  constructor(admin?) {
    if (admin.id) { this.id = admin.id; }
    this.email = admin.email;
    this.firstName = admin.firstName;
    this.lastName = admin.lastName;
    if (admin.password) { this.password = admin.password; }
    if (admin.firstName && admin.lastName) { this.fullName = `${admin.firstName} ${admin.lastName}`; }
  }

}
